import { NgModule } from '@angular/core';
import { TranslationSortPipe } from './pipes/translation-sort.pipe';
@NgModule({
    declarations: [
        TranslationSortPipe,
    ],
    exports: [
        TranslationSortPipe
    ],
    providers: [TranslationSortPipe]
})
export class SharedModule { }